const conversionMap = [
  ["ｳﾞｧ", "ﾊﾞ"],
  ["ｳﾞｨ", "ﾋﾞ"],
  ["ｳﾞｪ", "ﾍﾞ"],
  ["ｳﾞｫ", "ﾎﾞ"],
  ["ｳﾞｱ", "ﾊﾞ"],
  ["ｳﾞｲ", "ﾋﾞ"],
  ["ｳﾞｴ", "ﾍﾞ"],
  ["ｳﾞｵ", "ﾎﾞ"],
  ["ｳﾞ", "ﾌﾞ"],
  ["ｧ", "ｱ"],
  ["ｨ", "ｲ"],
  ["ｩ", "ｳ"],
  ["ｪ", "ｴ"],
  ["ｫ", "ｵ"],
  ["ｯ", "ﾂ"],
  ["ｬ", "ﾔ"],
  ["ｭ", "ﾕ"],
  ["ｮ", "ﾖ"],
  [" ", ""],
  ["･", ""],
  ["-", "ｰ"],
];

function conversionForCheck(str: string): string {
  let result = str;
  for (let [key, value] of conversionMap) {
    result = result.replaceAll(key, value);
  }

  return result;
}

/**
 * 業務チェック
 * @param name1 変更前口座名義ｶﾅ
 * @param name2 変更後口座名義ｶﾅ
 * @returns エラーメッセージ
 */
function businessCheck(
  name1: string,
  name2: string,
  file?: boolean
): "TKMSG_SCR0072E" | "TKMSG_SCR0127E" | "TKMSG_SCR0008W" | "" {
  let fullName1 = conversionForCheck(name1);
  let fullName2 = conversionForCheck(name2);
  let firstName1 = conversionForCheck(name1.split(" ")[1]);
  let firstName2 = conversionForCheck(name2.split(" ")[1]);

  if (fullName1 !== fullName2) {
    // 【No.230】氏名が変更されていることを確認できる書類の必須チェック
    if (firstName1 === firstName2 && !file) {
      return "TKMSG_SCR0127E";
    }

    // 【No.48、No.133】請求者名（ﾌﾘｶﾞﾅ）と口座名義（ﾌﾘｶﾞﾅ）が一致しない（名は合致/前方一致）チェック
    if (firstName1 === firstName2 || fullName2.indexOf(fullName1) === 0) {
      return "TKMSG_SCR0008W";
    }

    // 【No.134】請求者名（ﾌﾘｶﾞﾅ）と口座名義（ﾌﾘｶﾞﾅ）が一致しないチェック
    return "TKMSG_SCR0072E";
  }

  return "";
}

export { businessCheck };
